export default __webpack_public_path__ + "static/media/KOD0082-min.c93f8390.webp";